'use client'

import type { CSSProperties } from 'react'

import css from './arcade-embed.module.css'
import cn from 'clsx'

type ArcadeEmbedProps = {
    options: string
    iframeClassName?: string
    className?: string
    style?: CSSProperties
}

export function ArcadeEmbed({
    options,
    className = '',
    iframeClassName = '',
    style = {},
}: ArcadeEmbedProps) {
    return (
        <div className={cn(css.embedContainer, className)}>
            <iframe
                src={`https://demo.arcade.software/${options}`}
                title="Todoist for teams interactive demo"
                loading="lazy"
                allowFullScreen
                allow="clipboard-write"
                className={cn(css.iframe, iframeClassName)}
                style={style}
            />
        </div>
    )
}
